const formatHoursToText = (hours: number | null) => {
  if (hours === null || Number.isNaN(hours)) return "";

  const fullHours = Math.floor(hours);
  const minutes = Math.round((hours - fullHours) * 60);

  if (minutes === 0) return `${fullHours}h`;
  return `${fullHours}h ${minutes}min`;
};

export default formatHoursToText;
